import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75ca49b5"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, null, -1))
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "pages" }
const _hoisted_4 = { class: "copyright" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Brands = _resolveComponent("Brands")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Brands)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, { to: _ctx.privacyPolicyLink }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('navigation.footer.privacyPolicy')), 1)
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode(_component_router_link, { to: _ctx.termsOfUseLink }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('navigation.footer.termsOfUse')), 1)
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode(_component_router_link, { to: _ctx.cookiePolicyLink }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('navigation.footer.cookiePolicy')), 1)
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, " Copyright © 2023 " + _toDisplayString(_ctx.$t('navigation.navbar.appTitle')) + ". All Rights Reserved ", 1)
  ]))
}